import 'bootstrap/dist/css/bootstrap.css';
import './styles/reactSwitch.css';
import React from 'react';
import ReactDOM from 'react-dom';
import { BrowserRouter } from 'react-router-dom';
import App from './App';

//import registerServiceWorker from './registerServiceWorker';

//REF: https://docs.microsoft.com/en-us/azure/active-directory/develop/tutorial-v2-react

import { PublicClientApplication } from "@azure/msal-browser";
import { MsalProvider } from "@azure/msal-react";
import { msalConfig } from "./authConfig";

const baseUrl = document.getElementsByTagName('base')[0].getAttribute('href');
const rootElement = document.getElementById('root');

//REF: https://docs.microsoft.com/en-us/azure/active-directory/develop/tutorial-v2-react
const msalInstance = new PublicClientApplication(msalConfig);

ReactDOM.render(
  <React.StrictMode>
    <MsalProvider instance={msalInstance}>
      <BrowserRouter basename={baseUrl}>
        <App>
        </App>
      </BrowserRouter>
    </ MsalProvider>
  </React.StrictMode>,
  rootElement);

// Uncomment the line above that imports the registerServiceWorker function
// and the line below to register the generated service worker.
// By default create-react-app includes a service worker to improve the
// performance of the application by caching static assets. This service
// worker can interfere with the Identity UI, so it is
// disabled by default when Identity is being used.
//
//registerServiceWorker();

